export const HotelDetails = (props) => {
  const { hotelInfo, branding } = props;
  return (
    <div
      className="justify-content-between"
      style={{
        gap: "20px",
        marginBottom: "20px",
      }}
    >
      <div>
        <img
          src={hotelInfo.logo}
          alt="Hotel Logo"
          style={{
            maxWidth: "100px",
            borderRadius: "10px",
          }}
        />
      </div>
      <div style={{ textAlign: "right", lineHeight: "1" }}>
        <h1
          style={{
            fontSize: "50px",
            fontWeight: "bold",
            color: branding.roomNameColor,
          }}
        >
          {hotelInfo.hotelName}
        </h1>
        <div
          className="flex-direction-column"
          style={{ alignItems: "flex-end", gap: "5px" }}
        >
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <p style={{ margin: 0 }}>Address: {hotelInfo.address},</p>
            <p style={{ margin: 0 }}>Phone: {hotelInfo.phoneNumber}</p>
          </div>
          <div
            style={{
              display: "flex",
              gap: "15px",
              marginTop: "5px",
              flexWrap: "wrap",
            }}
          >
            <p style={{ margin: 0 }}>
              Website:{" "}
              <a
                href={hotelInfo.socialMediaLinks?.officialWebsite}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#007bff", textDecoration: "underline" }}
              >
                {hotelInfo.socialMediaLinks?.officialWebsite || "N/A"}
              </a>
            </p>
            <p style={{ margin: 0 }}>Email: {hotelInfo.email}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
